import { Strategy } from './twitch-strategy';

const OAuth2Strategy = Strategy;
export { Strategy, OAuth2Strategy };